import { requireNativeViewManager } from 'expo-modules-core';
import * as React from 'react';

export type ExpoCompressViewProps = {
  name: number;
};

type ExpoCompressViewState = {}

const NativeView: React.ComponentType<ExpoCompressViewProps> =
  requireNativeViewManager('ExpoCompress');

export default class ExpoCompressView extends React.Component<ExpoCompressViewProps, ExpoCompressViewState> {
  render() {
    return <NativeView name={this.props.name} />;
  }
}
